import { BaseUrl } from './index';
import { BaseFetch } from './baseService';

export const getConsultationReport = async (hash, options) => {
  return await BaseFetch(BaseUrl + `/api/consultation/report/render.v4?identify=${hash}`, options);
};
